module.exports = __webpack_public_path__ + "static/250530_Investor_Presentation_final-1764d01d1431e940a6d3e7e8cd39328e.pdf";